import { Plus, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import type { ServiceChargeWeightInput } from '@/services/compensation/serviceChargeService';

interface ServiceChargeWeightsFormProps {
  weights: ServiceChargeWeightInput[];
  onChange: (weights: ServiceChargeWeightInput[]) => void;
}

export const ServiceChargeWeightsForm = ({ weights, onChange }: ServiceChargeWeightsFormProps) => {
  const addWeight = () => {
    onChange([
      ...weights,
      {
        period_id: '',
        weight_label: '',
        weight_multiplier: 1.0,
        display_order: weights.length + 1,
      },
    ]);
  };

  const removeWeight = (index: number) => {
    onChange(weights.filter((_, i) => i !== index));
  };

  const updateWeight = (index: number, updates: Partial<ServiceChargeWeightInput>) => {
    const newWeights = [...weights];
    newWeights[index] = { ...newWeights[index], ...updates };
    onChange(newWeights);
  };

  return (
    <div className="space-y-4">
      {weights.map((weight, index) => (
        <div key={index} className="border rounded-lg p-4 space-y-4">
          <div className="flex justify-between items-start">
            <div className="flex-1 space-y-4">
              <div>
                <Label>Weight Label</Label>
                <Input
                  placeholder="e.g., 100% contract"
                  value={weight.weight_label}
                  onChange={(e) => updateWeight(index, { weight_label: e.target.value })}
                />
              </div>

              <div>
                <Label>Weight Multiplier</Label>
                <Input
                  type="number"
                  step="0.01"
                  min="0.01"
                  max="10.0"
                  placeholder="e.g., 1.0, 0.5, 0.25"
                  value={weight.weight_multiplier}
                  onChange={(e) =>
                    updateWeight(index, {
                      weight_multiplier: parseFloat(e.target.value) || 0,
                    })
                  }
                />
                <p className="text-xs text-muted-foreground mt-1">
                  Range: 0.01 – 10.0. Use 1.0 for full-time, 0.5 for half-time, etc.
                </p>
              </div>
            </div>

            <Button
              type="button"
              variant="ghost"
              size="icon"
              onClick={() => removeWeight(index)}
              className="ml-2"
            >
              <Trash2 className="h-4 w-4" />
            </Button>
          </div>
        </div>
      ))}

      <Button type="button" variant="outline" onClick={addWeight} className="w-full">
        <Plus className="h-4 w-4 mr-2" />
        Add Weight Category
      </Button>
    </div>
  );
};
